import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Select, Button, Input, Collapse, Table, Icon, Modal } from 'antd';
import EmailSettings from '../userSettings/EmailSettings';
import schoolConstants from '../../constants/schoolConstants';
import columns from '../prospectIdentification/TableColumns';
import getUserProfile from '../../userFunctions/getUserProfile';
import store from '../../reducers/store';
import editUser from '../../userFunctions/editUser';
import createTargetUserProfile from '../../userFunctions/createTargetUserProfile';
import deleteTargetUserProfile from '../../userFunctions/deleteTargetUserProfile';
import EditFilterModal from '../prospectIdentification/EditModal';
import EditForm from './EditForm.js';

import userService from '../../services/userService';

const Panel = Collapse.Panel;
const confirm = Modal.confirm;
const Option = Select.Option;

class SuperSettings extends Component {
  constructor(props) {
    super(props);

    this.userService = userService;
    this.state = {
      schoolUsersList: [],
      admin: [],
      showEditModal: false,
      key: '',
      name: '',
      email: '',
      modalTitle: 'Edit User',
      role: 'Collaborator',
      errorMessage: '',
      hasError: false,
    };
  }

  getRows() {
    return new Promise((resolve, reject) => {
      let rows = [];
      getUserProfile().then((profile) => {
        for (var user of profile.SchoolUsers) {
          user.Role = user.SuperUser ? 'Administrator' : 'Collaborator';

          rows.push(user);
        }
        resolve(rows);
      });
    });
  }

  getUsers() {
    return this.props.schoolUsersList;
  }

  openEditModal(type, action, key) {
    var role, email;
    var schoolUsersList = JSON.parse(JSON.stringify(this.state.schoolUsersList));
    var userWithKey = schoolUsersList.find((user) => {
      return user.key == key;
    });

    if (action == 'Edit') {
      role = userWithKey.role;
      email = userWithKey.email;
    } else {
      role = 'Collaborator';
      email = '';
    }

    if (action == 'Create') {
      role = this.state.role;
      email = this.state.email;
    }

    this.setState({
      showEditModal: true,
      type: type,
      action: action,
      key: key,
      modalTitle: `${action} User`,
      role: role,
      email: email,
      hasError: false,
    });
  }

  handleOk(event) {
    if (this.state.action == 'Edit') {
      this.updateUser(this.state.key);
    } else {
      this.createUser();
    }

    this.setState({
      showEditModal: false,
      type: '',
      action: '',
      key: '',
      role: '',
      email: '',
      hasError: false,
    });
  }

  handleCancel() {
    this.setState({
      showEditModal: false,
      type: '',
      action: '',
      key: '',
      name: '',
      role: '',
      email: '',
      hasError: false,
    });
  }

  showConfirmDeleteUser(key) {
    var that = this;
    confirm({
      title: 'Are you sure you want to delete this user?',
      onOk() {
        that.deleteUser(key);
        return;
      },
      onCancel() {
        return;
      },
    });
  }

  deleteUser(key) {
    this.userService.deleteUser(key).then(() => {
      userService.getUsersFromOrg(localStorage.organization_id);
    });
  }

  updateUser(key) {
    var schoolUsersList = JSON.parse(JSON.stringify(this.state.schoolUsersList));
    var userWithKey = schoolUsersList.find((user) => {
      return user.key == key;
    });
    var index = schoolUsersList.indexOf(userWithKey);
    var newUser = userWithKey;
    var newUsersList = schoolUsersList.slice();

    var newVals = {
      email: this.state.email,
      role: this.state.role,
    };
    newUser.email = newVals.email;
    newUser.role = newVals.role;

    if (index > -1) {
      newUsersList[index] = newUser;
    }

    this.userService.editUser(newUser).then((res) => {
      userService.getUsersFromOrg(localStorage.organization_id);
    });
  }

  createUser() {
    var newVals = {
      email: this.state.email,
      role: this.state.role,
    };

    this.userService
      .createUser(this.state.email, this.state.role)
      .then((user) => {
        userService.getUsersFromOrg(localStorage.organization_id);
      })
      .catch((err) => {
        const errorMessage = '*' + err.message;
        this.setState({
          errorMessage,
          hasError: true,
        });
      });

    // editUser('', 'create', newVals).then((data) => {
    //   var newList = store.getState().lists.schoolUsersList
    //   var userObj = newList.slice(-1)[0]
    //   this.updateUserRows(userObj)
    //   this.createDbProfile(data.User, false)
    // })
  }

  createDbProfile(user, parsed) {
    var email = '';
    var name = '';
    var id = '';
    if (parsed) {
      email = user.email;
      id = user.key;
    } else {
      id = id.Value;
      email = emailAtt.Value;
    }

    if (email != '') {
      createTargetUserProfile(name, email, id);
    } else {
    }
  }

  transformUserIntoRow(userObj) {
    var email = userObj.username;
    var key = userObj.id;
    var newRole = userObj.super_user ? 'Administrator' : 'Collaborator';
    var mapping = { email: email, role: newRole, key: key };

    return mapping;
  }

  updateUserRows(userObj) {
    var parsedUser = this.transformUserIntoRow(userObj);

    var newUsersList = this.state.schoolUsersList;

    newUsersList.push(parsedUser);

    newUsersList.sort(function (a, b) {
      if (a.name > b.name) {
        return 1;
      } else {
        return b.name > a.name ? -1 : 0;
      }
    });

    this.setState({
      schoolUsersList: newUsersList,
      hasError: false,
    });
  }

  componentWillMount() {
    var newUsers = this.props.schoolUsersList.map((user) => {
      const role = user.super_user ? 'Administrator' : 'Collaborator';
      var mapping = { email: user.username, role: role, key: user.id };
      return mapping;
    });

    this.setState({
      schoolUsersList: newUsers,
    });
  }

  componentWillReceiveProps(nextProps) {
    var newUsers = nextProps.schoolUsersList.map((user) => {
      const role = user.super_user ? 'Administrator' : 'Collaborator';
      var mapping = { email: user.username, role: role, key: user.id };
      return mapping;
    });

    this.setState({
      schoolUsersList: newUsers,
      hasError: false,
    });
  }

  receiveFormData(data) {
    this.setState({ ...data });
  }

  render() {
    const optionsColumn = [
      {
        title: '',
        key: 'options',
        width: 50,
        render: (text, record) => (
          <div className='row-option edit-delete-container'>
            <Icon
              type='edit'
              role='button'
              tabIndex={0}
              aria-label={`Edit User ${record.email}`}
              onClick={() => {
                this.openEditModal('User', 'Edit', record.key);
              }}
            />
            <Icon
              type='close-square-o'
              role='button'
              tabIndex={0}
              aria-label={`Delete User ${record.email}`}
              onClick={() => {
                this.showConfirmDeleteUser(record.key);
              }}
            />
          </div>
        ),
      },
    ];

    const ManageUsersColumns = columns.ManageUsersColumns.concat(optionsColumn);
    return (
      <div>
        {this.state.hasError && <p className='error-message'>{this.state.errorMessage}</p>}
        <Table
          columns={ManageUsersColumns}
          dataSource={this.state.schoolUsersList}
          locale={{ emptyText: 'No Users To Manage' }}
          title={() => (
            <div>
              <span className='table-title-span'>Manage Users</span>{' '}
              <Button
                style={{ float: 'right' }}
                type='primary'
                aria-label='Add a User'
                className='addButton'
                onClick={() => {
                  this.openEditModal('User', 'Create', '');
                }}>
                + Add
              </Button>
            </div>
          )}
          pagination={false}
        />
        <Modal
          visible={this.state.showEditModal}
          action={this.state.action}
          onOk={this.handleOk.bind(this)}
          onCancel={this.handleCancel.bind(this)}
          title={this.state.modalTitle}
          okText={'Submit'}>
          <EditForm
            email={this.state.email}
            role={this.state.role}
            sendToParent={this.receiveFormData.bind(this)}
            type={this.state.action}
          />
        </Modal>
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    schoolUsersList: storeState.lists.schoolUsersList,
    redirected: storeState.main.redirected,
  };
}

export default connect(mapStoreToProps)(SuperSettings);



// WEBPACK FOOTER //
// ./src/components/superUser/SuperSettings.js